import { render, staticRenderFns } from "./Anxiety.vue?vue&type=template&id=36624894&"
import script from "./Anxiety.vue?vue&type=script&lang=js&"
export * from "./Anxiety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports